// extracted by mini-css-extract-plugin
export default {"participantsLoadingContainer":"ParticipantsListLoading-module__participantsLoadingContainer__BgGvPvt"};